import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { ObjectPropsPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { PaginationContext } from '../../contexts/pagination';
import './PaginationInfiniteScrollTrigger.less';
var defaultProps = {
  className: '',
  hide: false,
  showMoreButtonProps: {}
};
export default function PaginationInfiniteScrollTrigger(_ref) {
  var className = _ref.className,
    hide = _ref.hide,
    showMoreButtonProps = _ref.showMoreButtonProps;
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination;
  var activePage = pagination.activePage,
    totalPages = pagination.totalPages,
    onNextPage = pagination.onNextPage;
  if (totalPages <= 1 || hide || activePage === totalPages) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    'pagination-infinite-scroll': true
  }, className, className));
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onNextPage,
    content: "Show More"
  }, getButtonProps(showMoreButtonProps || {}))));
}
PaginationInfiniteScrollTrigger.defaultProps = defaultProps;